exports.firebaseConfig = {
  apiKey: 'AIzaSyDSYe_lUCysUPhhGPZ9DpFAVizSFracSBE',
  authDomain: 'vietlott-52ced.firebaseapp.com',
  projectId: 'vietlott-52ced',
  messagingSenderId: '1008696483090',
  appId: '1:1008696483090:web:b6f9590b31daf2d2b367cb',
  measurementId: 'G-QJBQBYWWVQ'
};
